// src/pages/auth/CorreoConfirmado.jsx
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import "./correoconfirmado.css";

function CorreoConfirmado() {
  const { user } = useContext(AuthContext);
  // Si existe el usuario, verificamos su tipo; en caso contrario, redirigimos al login general
  const loginLink = user
    ? (user.userType === "employer" ? "/login?role=employer" : "/login?role=user")
    : "/login";

  return (
    <div className="correo-confirmado-container">
      <h1 className="display-4 correo-confirmado-title">¡Correo Confirmado!</h1>
      <p className="correo-confirmado-text">
        Tu correo electrónico ha sido verificado exitosamente.
      </p>
      <p className="correo-confirmado-text">
        Ahora puedes iniciar sesión y disfrutar de nuestros servicios.
      </p>
      <Link to={loginLink} className="submit-button">
        Inicia Sesión
      </Link>
    </div>
  );
}

export default CorreoConfirmado;